module.exports = __webpack_public_path__ + "static/karla-bold-9119a98f8dcacf2e95db9286d268ba7d.woff2";